// @flow

import React from 'react';

import Card from './Card';
import Checkbox from './CheckboxInput';

type Props = {
  noShadow?: boolean,
  className?: string,
  classNameHeader?: string,
  noBorder?: boolean,
  children?: any,
  header?: any,
  noPadding?: boolean,
  showCheckbox?: boolean,
  toggleCardCheckbox?: (resourceId: any) => void,
  id?: any,
  isSelected?: boolean
}

const CardSplit = ({ noShadow, header, noBorder, showCheckbox, isSelected, toggleCardCheckbox,
  noPadding, className, classNameHeader, children, id }: Props) => {
  return (
    <Card
      id={id}
      noPadding
      noShadow={noShadow}
      noBorder={noBorder}
      selected={isSelected}
      addCheckboxLabel={showCheckbox}
      className={`card__split ${className || ''}`}
    >
      <div>
        {showCheckbox ?
          <Checkbox
            id={id}
            onToggle={toggleCardCheckbox}
            className={'card__checkbox'}
            checked={isSelected}
            key={id}
          />
        : ''}
      </div>
      <div className={`card__split-container ${isSelected ? 'is-selected' : ''}`}>
        <div className={`card__split-header ${classNameHeader} bottom-border`}>
          {header}
        </div>
        <div className={!noPadding && 'card__split-content'}>
          {children}
        </div>
      </div>
    </Card>
  );
};

export default CardSplit;



// WEBPACK FOOTER //
// ./src/components/shared/CardSplit.js